
import { LinkPlugin as LexicalLinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import * as React from "react";

export default function LinkPlugin(): JSX.Element {
    return <LexicalLinkPlugin />;
}
